/* eslint-disable no-console */
import store from '@/plugins/store';

const ret = new Object();
ret.info = (content) => store.commit('showMessageDialog', { type: 'info', content: content })
ret.error = (content) => store.commit('showMessageDialog', { type: 'error', content: content })
ret.warn = (content) => store.commit('showMessageDialog', { type: 'warn', content: content })
ret.success = (content) => store.commit('showMessageDialog', { type: 'success', content: content })
ret.alert = (content) => store.commit('showMessageDialog', { type: 'alert', content: content })
ret.confirm = (content, okFn, cancelFn) => store.commit('showMessageDialog', { type: 'confirm', content: content, okFn: okFn, cancelFn: cancelFn })
ret.prompt = (content, defaultValue, okFn, cancelFn) => store.commit('showMessageDialog', { type: 'prompt', content: content, defaultValue: defaultValue, okFn: okFn, cancelFn: cancelFn })

export default ret